export default __webpack_public_path__ + "static/media/Shrimp.b76c51a7.webp";